<template>
  <ScreenWidthProvider
    v-slot="{ isWider }"
    class="tab-pane product-content__hotel-list pt-12 mb-6"
    role="tabpanel"
  >
    <template v-if="isWider('md') && shouldShowCarousel">
      <div class="film-tab-title mb-6 pb-2">
        <h4
          class="mb-1"
          data-i18n="trip.moviesTab.title"
        >
          {{ $t('trip.moviesTab.title') }}
        </h4>
        <div
          v-if="firstFilm?.title"
          class="inline-flex flex-row items-center"
        >
          <hr class="mr-4" />
          <span :data-translation="firstFilm?.title_translationkey">
            {{ firstFilm?.title }}
          </span>
        </div>
      </div>
      <LazyMediaCarousel
        class="film-tab-carousel mt-2 mb-12"
        :slides="mediaSlide"
        :slides-per-view="mediaSlide.length > 3 ? 3 : mediaSlide.length"
        arrows-size="sm"
        constant-display-navigation
        allow-fullscreen
        :pagination="false"
        scene
        slide-to-clicked-slide
      />
    </template>
    <div
      v-else
      class="film-tab-layout-2 pb-12"
    >
      <h5
        class="mb-1"
        data-i18n="trip.moviesTab.title"
      >
        {{ $t('trip.moviesTab.title') }}
      </h5>
      <div
        v-for="(film, idx) in filteredFilms"
        :key="idx"
        class="mb-4"
      >
        <div
          class="mb-4"
          :data-translation="film?.title_translationkey"
        >
          {{ film.title }}
        </div>
        <LazyMediaPlayer
          :url="film.film"
          :type="film.filmtype"
        />
      </div>
    </div>
  </ScreenWidthProvider>
</template>

<script>
export default defineNuxtComponent({
  props: {
    films: {
      type: Array,
      required: true,
    },
  },

  data () {
    return {
      modal: false,
      selectedFilm: null,
    }
  },

  computed: {
    filteredFilms () {
      return this.films.filter(f => !!f.film)
    },

    firstFilm () {
      return this.filteredFilms?.[0]
    },

    mediaSlide () {
      return this.filteredFilms.map(film => ({
        mediatype: 'video',
        type: film.filmtype,
        url: film.film,
        modalTitle: film.title,
      }))
    },

    shouldShowCarousel () {
      return this.films?.length > 2
    },
  },

  methods: {
    openFilm (f) {
      this.selectedFilm = f
      this.modal = true
    },
  },
})
</script>

<style lang="scss">
@import "@layers/web/assets/scss/modules/product/_product-video";

.film-tab {
  &-title {
    hr {
      width: 30px;
      background: black;
    }
  }

  &-layout-2 {
    * {
      font-size: 1.1rem;
    }
  }
}

.movie-modal {
  height: 90vh;

  .modal-close-button {
    top: 0;
    right: 0;
  }
}
</style>
